import { Component, Inject, OnInit } from '@angular/core';
import { MatCheckboxChange, MatSelectChange } from '@angular/material';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExportColumn } from '../../models/export-column.model';
import { ExportParameters } from '../../models/export-parameters.model';
import { ExportType } from '../../models/export-type.model';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.css']
})
export class ExportComponent implements OnInit {
  dialog:any;
  type :ExportType;
  constructor(
    private dialogRef: MatDialogRef<ExportComponent>,
    @Inject(MAT_DIALOG_DATA) data ) {
    this.dialog = data;
   }

  ngOnInit() {
    if(this.dialog.options && this.dialog.options.length > 0) {
      this.type = this.dialog.options[0];
    }
  }
  close(){
    this.dialogRef.close();
  }

  onExportSelected(selected:MatSelectChange) {
    this.type = <ExportType>selected.value;
  }
  onColumnToggle(change:MatCheckboxChange, column: ExportColumn) {
    column.enabled = !(column.enabled);
  }
  export() {
    if (this.type) {      
      this.dialogRef.close(new ExportParameters(this.type, this.dialog.columns));
    }
  }
}

export function DownloadFile(url:string, name:string = null) {
  const file_path = url;
  const a:HTMLAnchorElement = <HTMLAnchorElement>document.createElement('A');
  a.href = file_path;
  if(!name) {
    name = file_path.substr(file_path.lastIndexOf('/') + 1);
  }  
  a.download = name;
  document.body.appendChild(a);
  console.log('DownloadFile',name,a.download);
  a.click();
  document.body.removeChild(a);
}